import React from 'react'
import PropTypes from 'prop-types'

const AgendaSingleItemHeader = ({postItem}) => {
	const cleanString = (str) => {
		try {
			if (!str) return []
			
			// Nettoyer les termes spécifiques
			let cleaned = str
				.replace(', Newsletter', '')
				.replace(', A la une', '')
				.replace(', A ne pas rater', '')
				.replace(', Site Zéro Déchet', '')
			
			// Diviser par virgules et filtrer les éléments vides
			const terms = cleaned.split(',').filter(item => item.trim())
			
			// Si aucun terme valide n'est resté après nettoyage, retourner le terme original
			if (terms.length === 0) {
				return [str.trim()]
			}
			
			return terms
		} catch (error) {
			console.error("Error cleaning string:", error)
			return [str || '']
		}
	}

	const formatParticipation = (participation) => {
		try {
			if (!participation) return ''
			return participation.replace('evenement-gratuit', 'Gratuit')
		} catch (error) {
			console.error("Error formatting participation:", error)
			return participation || ''
		}
	}

	try {
		if (!postItem || !postItem._source) {
			return null
		}

		const { terms_other, post_location_name, post_partiticpation, post_by_roubaix } = postItem._source

		return (
			<div 
				className="agenda-single-item-category"
				role="region"
				aria-label="Informations de l'événement"
				aria-describedby="event-info-description"
			>
				<div id="event-info-description" className="sr-only">
					Informations détaillées sur l'événement incluant les catégories, lieu, participation et organisateur
				</div>
				
				{terms_other && (
					<p 
						className="agenda-single-item-category-field agenda-single-item-category-other"
						role="text"
						aria-label="Catégories de l'événement"
					>
						{cleanString(terms_other).map((el, i) => (
							<span 
								key={i} 
								className="agenda-single-item-category-field-item agenda-single-item-category-other-item"
								role="text"
							>
								{el}
							</span>
						))}
					</p>
				)}
				
				{post_location_name && (
					<p 
						className="agenda-single-item-category-field agenda-single-item-category-location-name"
						role="text"
						aria-label="Lieu de l'événement"
					>
						<span className="agenda-single-item-category-field-item agenda-single-item-category-item-location-name">
							{post_location_name}
						</span>
					</p>
				)}
				
				{post_partiticpation && (
					<p 
						className="agenda-single-item-category-field agenda-single-item-category-partiticpation"
						role="text"
						aria-label="Conditions de participation"
					>
						<span className="agenda-single-item-category-field-item agenda-single-item-category-item-partiticpation">
							{formatParticipation(post_partiticpation)}
						</span>
					</p>
				)}
				
				{post_by_roubaix && (
					<p 
						className="agenda-single-item-category-field agenda-single-item-category-pbr"
						role="text"
						aria-label="Organisateur de l'événement"
					>
						<span className="agenda-single-item-category-field-item agenda-single-item-category-item-pbr">
							{post_by_roubaix}
						</span>
					</p>
				)}
			</div>
		)
	} catch (error) {
		console.error("Error rendering AgendaSingleItemHeader:", error)
		return null
	}
}

AgendaSingleItemHeader.propTypes = {
	postItem: PropTypes.shape({
		_source: PropTypes.shape({
			terms_other: PropTypes.string,
			post_location_name: PropTypes.string,
			post_partiticpation: PropTypes.string,
			post_by_roubaix: PropTypes.string
		})
	})
}

AgendaSingleItemHeader.defaultProps = {
	postItem: null
}

export default AgendaSingleItemHeader